<template>
  <content-dashboard :hide="true">
    <v-row>
      <!-- #inicio# NA Geradas -->
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" color="grey lighten-4" max-width="600">
          <v-card-title>
            <v-icon color="black" class="mr-12" size="65">mdi-shield-car</v-icon>

            <v-row align="start">
                <div>
                    <span class="display-5 font-weight-black mr-3" v-text="na_geradas"></span>
                    <strong class="grey--text text-uppercase">NA Geradas</strong>
                </div>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <!-- #fim# NA Geradas -->

      <!-- #inicio# NP Geradas -->
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" color="grey lighten-4" max-width="600">
          <v-card-title>
            <v-icon color="black" class="mr-12" size="65">mdi-barcode</v-icon>

            <v-row align="start">
              <div>
                <span class="display-5 font-weight-black mr-3" v-text="np_geradas"></span>
                <strong class="grey--text text-uppercase">NP Geradas</strong>
              </div>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <!-- #fim# NP Geradas -->

      <!-- #inicio# Penalidade Educativa -->
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" color="grey lighten-4" max-width="600">
          <v-card-title>
            <v-icon color="orange" class="mr-12" size="65">mdi-bell-ring</v-icon>

            <v-row align="start">
              <div>
                <span class="display-5 font-weight-black mr-3" v-text="ne_geradas"></span>
                <strong class="grey--text text-uppercase">Notificação Educativa</strong>
              </div>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <!-- #fim# Penalidade Educativa -->
    </v-row>

    <v-row>
      <!-- #inicio# Autos Estacionados Dentro Do Prazo -->
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" color="grey lighten-4" max-width="600" @click="downloadCsvAuditoria">
          <v-card-title>
            <v-icon color="red" class="mr-12" size="65">mdi-close-octagon</v-icon>

            <v-row align="start">
              <div>
                <span class="display-5 font-weight-black mr-3" v-text="autos_estacionados_dentro_do_prazo"></span>
                <strong class="grey--text text-uppercase">Estacionados Na Validade</strong>
              </div>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <!-- #fim# Autos Estacionados Dentro Do Prazo -->

      <!-- #inicio# Autos que se venceram semana passada -->
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" color="grey lighten-4" max-width="600" @click="downloadVencidosSemanaPassada">
          <v-card-title>
            <v-icon color="black" class="mr-12" size="65">mdi-calendar-minus</v-icon>

            <v-row align="start">
              <div>
                <span class="display-5 font-weight-black mr-3" v-text="autos_vencidos_semana_passada"></span>
                <strong class="grey--text text-uppercase">Vencidos Semana Passada</strong>
              </div>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <!-- #fim# Autos que se venceram semana passada -->

      <!-- #inicio# Autos que irão se vencer nessa semana -->
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" color="grey lighten-4" max-width="600" @click="downloadVencidosEssaSemana">
          <v-card-title>
            <v-icon color="red" class="mr-12" size="65">mdi-calendar-repeat</v-icon>

            <v-row align="start">
              <div>
                <span class="display-5 font-weight-black mr-3" v-text="autos_vencidos_essa_semana"></span>
                <strong class="grey--text text-uppercase">Vencendo Essa Semana</strong>
              </div>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <!-- #fim# Autos que irão se vencer nessa semana -->
    </v-row>

    <v-row>
      <!-- #inicio# Autos Aguardando Retorno -->
      <v-col cols="12" md="4" sm="12">
        <v-card class="mx-auto" color="grey lighten-4" max-width="600">
          <v-card-title>
            <v-icon color="indigo" class="mr-12" size="65">mdi-keyboard-return</v-icon>

            <v-row align="start">
              <div>
                <span class="display-5 font-weight-black mr-3" v-text="autos_aguardando_retorno"></span>
                <strong class="grey--text text-uppercase">Aguard. Retorno</strong>
              </div>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <!-- #fim# Autos Aguardando Retorno -->
    </v-row>

    <v-divider class="my-2 mb-10 mt-10"></v-divider>

    <v-card>
      <v-card-title class="subtitle-1">Filtros</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
              outlined
              dense
              v-model="filtro.data_inicial"
              label="Data Inicial"
              type="date"
              :rules="rules"
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
              outlined
              dense
              v-model="filtro.data_final"
              label="Data Final"
              type="date"
              :rules="rules"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="load(filtro)">Pesquisar</v-btn>
        <v-btn color="primary" outlined class="ml-5" @click="reset">Limpar</v-btn>
      </v-card-actions>
    </v-card>
  </content-dashboard>
</template>

<script>
  import urlApi from "@/routes/urlApi";
  import { showError } from "@/global";
  import queryString from "querystring";
  import downloadString from "../../utils/downloadString";

  export default {
    data() {
      return {
        loading: false,
        valid: true,
        rules: [v => !!v || "Este campo é Obrigatório"],
        filtro: {},
        autos_aguardando_retorno: 0,
        na_geradas: 0,
        np_geradas: 0,
        ne_geradas: 0,
        autos_vencidos_essa_semana: 0,
        autos_vencidos_semana_passada: 0,
        autos_estacionados_dentro_do_prazo: 0
      };
    },

    methods: {
      load(filtro) {
        this.$store.commit("overlay/toggle", true);

        let filter = '';

        if (filtro) {
          if (!this.$refs.form.validate()) return;
          filter = queryString.stringify(filtro);
        }
        
        const url = `${urlApi}/auditoria/novo-dashboard?${filter}`;

        this.$http.get(url).then(res => {
          const response = res.data.dados;

          this.autos_aguardando_retorno = response.autos_aguardando_retorno_detran;
          this.na_geradas = response.na_envios;
          this.ne_geradas = response.ne_envios;
          this.np_geradas = response.np_envios;
          this.autos_vencidos_essa_semana = response.autos_vencidos_essa_semana;
          this.autos_vencidos_semana_passada = response.autos_vencidos_semana_passada;
          this.autos_estacionados_dentro_do_prazo = response.autos_estacionados_dentro_do_prazo;

          this.$store.commit("overlay/toggle", false);
        }).catch(error => {
          this.$store.commit("overlay/toggle", false);
          showError('Não foi possível carregar os dados.');
        });
      },

      reset() {
        this.filtro = {};
      },

      downloadCsvAuditoria() {
        this.$store.commit("overlay/toggle", true);

        const url = `${urlApi}/auditoria/download-csv`;

        this.$http.get(url).then(res => {
            downloadString(res.bodyText, "text/csv", 'relatorio-auditoria-diaria.csv');
            this.$store.commit("overlay/toggle", false);
        }).catch(error => {
            this.$store.commit("overlay/toggle", false);
            showError("Não foi possível realizar o download do relatório de auditoria diário.");
        });
      },

      downloadVencidosEssaSemana() {
        this.$store.commit("overlay/toggle", true);

        const url = `${urlApi}/auditoria/download-autos-vencidos-essa-semana`;

        this.$http.get(url).then(res => {
            downloadString(res.bodyText, "text/csv", 'autos-vencidos-essa-semana.csv');
            this.$store.commit("overlay/toggle", false);
        }).catch(error => {
            this.$store.commit("overlay/toggle", false);
            showError("Não foi possível realizar o download do relatório de autos vencidos essa semana.");
        });
      },

      downloadVencidosSemanaPassada() {
        this.$store.commit("overlay/toggle", true);

        const url = `${urlApi}/auditoria/download-autos-vencidos-semana-passada`;

        this.$http.get(url).then(res => {
          downloadString(res.bodyText, "text/csv", 'autos-vencidos-semana-passada.csv');
          this.$store.commit("overlay/toggle", false);
        }).catch(error => {
          this.$store.commit("overlay/toggle", false);
          showError("Não foi possível realizar o download do relatório de autos vencidos semana passada.");
        });
      }
    },

    created() {
      this.load();
    }
  }
</script>
